<div class="bg-white rounded-lg">

  <!-- ── Skeleton loader ───────────────────────────────────────────────── -->
  <ng-container *ngIf="loading; else contentState">
    <div class="animate-pulse">
      <div class="h-5 bg-light-blue rounded-3xl w-full"></div>
      <div class="flex flex-wrap gap-x-6 gap-y-2 mt-4">
        <div *ngFor="let cat of this.chartConfig?.categories" class="flex items-center gap-2">
          <div class="w-3.5 h-3.5 rounded-full bg-light-blue"></div>
          <div class="h-3 bg-light-blue rounded w-20"></div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #contentState>
    <!-- ── Data present: render the ECharts bar ─────────────────────────── -->
    <ng-container *ngIf="hasData; else emptyState">
      <div
        echarts
        [options]="chartOptions"
        class="w-full"
        style="height: 64px;"
        (chartInit)="onChartInit($event)">
      </div>
    </ng-container>

    <!-- ── Empty state ──────────────────────────────────────────────────── -->
    <ng-template #emptyState>
      <div class="flex items-center justify-center py-3 text-sm text-gray-400">
        No service call data available
      </div>

      <!-- Disabled-looking manual legend -->
      <div class="flex flex-wrap mt-2" style="gap: 24px;">
        <div
          *ngFor="let cat of this.chartConfig?.categories"
          class="flex items-center text-xs text-gray-400"
          style="gap: 6px;">
          <span
            class="inline-block w-2.5 h-2.5 rounded-full opacity-40"
            [style.backgroundColor]="cat.color">
          </span>
          <span>{{ cat.label }}</span>
        </div>
      </div>
    </ng-template>

  </ng-template>

</div>
